import React, {FC} from "react"

import FormattedMessage, {injectIntl, InjectIntl} from "@irati/utils/lang"
import Flex from "@irati/ui/src/Flex"
import Link from "@irati/ui/src/Link"

import {Img, ProviderLabel} from "./styled"

interface Props extends InjectIntl {}

const Providers: FC<Props> = ({formatMessage}) => {
  return (
    <Flex justifyContent="space-between" wrap="wrap" gap={3} padding={[2, 4]}>
      <ProviderLabel>
        <Img small src={formatMessage({id: "admin.components.integration.directorySync.hris.providers.img1"})} />
      </ProviderLabel>
      <ProviderLabel>
        <Img small src={formatMessage({id: "admin.components.integration.directorySync.hris.providers.img2"})} />
      </ProviderLabel>
      <ProviderLabel>
        <Img small src={formatMessage({id: "admin.components.integration.directorySync.hris.providers.img3"})} />
      </ProviderLabel>
      <ProviderLabel>
        <Img small src={formatMessage({id: "admin.components.integration.directorySync.hris.providers.img4"})} />
      </ProviderLabel>
      <ProviderLabel>
        <Img small src={formatMessage({id: "admin.components.integration.directorySync.hris.providers.img5"})} />
      </ProviderLabel>
      <ProviderLabel>
        <Img small src={formatMessage({id: "admin.components.integration.directorySync.hris.providers.img6"})} />
      </ProviderLabel>
      <ProviderLabel>
        <Link small tertiary href={formatMessage({id: "admin.components.integration.directorySync.hris.providers.link"})} target="_blank">
          <FormattedMessage id="admin.components.integration.directorySync.hris.providers.viewAll" />
        </Link>
      </ProviderLabel>
    </Flex>
  )
}

export default injectIntl(Providers)
